import type { ServiceTypeEnum } from "bonusx-api-main-manager";
import { Expose } from "class-transformer";
import type { CmsProductIseeRequirementEnum } from "../../../../services/ApiClientBonusxCmsRepository/enums/cms-product-isee-requirement.enum";
import type { CmsProductStatusEnum } from "../../../../services/ApiClientBonusxCmsRepository/enums/cms-product-status.enum";
import type { CmsProductTypeEnum } from "../../../../services/ApiClientBonusxCmsRepository/enums/cms-product-type.enum";
import type { IProductLeanDto } from "./product-lean.dto.interface";

export class ProductLeanDto implements IProductLeanDto {
  @Expose({ name: "shortDescription" })
  shortDescription!: string;

  @Expose({ name: "available" })
  available!: boolean;

  @Expose({ name: "type" })
  type!: ServiceTypeEnum;

  @Expose({ name: "subType" })
  subType!: CmsProductTypeEnum;

  @Expose({ name: "name" })
  name!: string;

  @Expose({ name: "labels" })
  labels!: string[];

  @Expose({ name: "id" })
  id!: number;

  @Expose({ name: "uniqueIdentifier" })
  uniqueIdentifier!: string;

  @Expose({ name: "requiredIsee" })
  requiredIsee!: CmsProductIseeRequirementEnum;

  @Expose({ name: "status" })
  status!: CmsProductStatusEnum;

  @Expose({ name: "category" })
  category!: number;

  @Expose({ name: "visibleFromTier" })
  visibleFromTier!: string;

  @Expose({ name: "requestableFromTier" })
  requestableFromTier!: string;

  @Expose({ name: "isRequestable" })
  isRequestable?: boolean;

  @Expose({ name: "isVisible" })
  isVisible?: boolean;

  @Expose({ name: "manageWithBonusx" })
  manageWithBonusx?: boolean;

  @Expose({ name: "orderedTiersThatCanRequestProduct" })
  orderedTiersThatCanRequestProduct: string[] | undefined;

  constructor(data?: IProductLeanDto) {
    if (data) {
      this.shortDescription = data.shortDescription;
      this.available = data.available;
      this.type = data.type;
      this.subType = data.subType;
      this.name = data.name;
      this.labels = data.labels;
      this.id = data.id;
      this.uniqueIdentifier = data.uniqueIdentifier;
      this.requiredIsee = data.requiredIsee;
      this.status = data.status;
      this.category = data.category;
      this.visibleFromTier = data.visibleFromTier;
      this.requestableFromTier = data.requestableFromTier;
      this.isRequestable = data.isRequestable;
      this.isVisible = data.isVisible;
      this.manageWithBonusx = data.manageWithBonusx;
      this.orderedTiersThatCanRequestProduct = data.orderedTiersThatCanRequestProduct;
    }
  }
}
